/**
 * 安装引导页懒加载壳（16b；AboutLazy 同构）：低频页不进首屏 bundle。
 */
import { useLazyModule } from './useLazyModule';

export function InstallLazy() {
  const { mod } = useLazyModule(() => import('./InstallPage'));
  if (mod === null) return <div data-testid="install-loading-shell">加载中…</div>;
  return <mod.InstallPage />;
}
